/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardIcon from './img/dashboard.svg';
import LiveIcon from './img/live.svg';
import './navigation.css';
// import LiveIcon from '../../image/liveIcon.svg';
import NotificationBadge from '../notification/NotificationBadge';
import Agencies from './img/agencies.svg';
import InsightsIcon from './img/insights.svg';
import Inventory from './img/inventory.svg';
import Notifications from './img/notifications.svg';
import SettingsIcon from './img/settings.svg';
import SupportIcon from './img/support.svg';
import FleetIcon from './img/fleetAI.svg';
import AnalyticsIcon from './img/analyticsIcon.svg';

const Navigation = (props) => {
    const navigate = useNavigate();
    const {
      text, navigationState, setNavigationState, value, path, setNavigationClick, showMenu, setShowMenu, data,
    } = props;

    const notificationAmount = (num) => {
        const notificationValue = num?.filter((x) => x.read === false).length;
        if (notificationValue > 99) return '99+';
        if (notificationValue > 0) return notificationValue;
        return '0';
    };

    const stateChange = (e, nameValue) => {
        // e.preventDefault();
        setNavigationState(nameValue);
        navigate(path, { replace: true });
        setNavigationClick(1);
        // console.log('nameValue', nameValue);
    };

    const isActive = navigationState === value;

    function navIcon() {
        switch (text) {
            case 'Dashboard':
                return <img loading="lazy" src={DashboardIcon} className="icon-nav" alt="nav-icon-dashboard" />;
            case 'Live':
                return <img loading="lazy" src={LiveIcon} className="icon-nav" alt="nav-icon-live" />;
            case 'Insights':
                return <img loading="lazy" src={InsightsIcon} className="icon-nav" alt="nav-icon-insights" />;
            case 'Settings':
                return <img loading="lazy" src={SettingsIcon} className="icon-nav" alt="nav-icon-settings" />;
            case 'Support':
                return <img loading="lazy" src={SupportIcon} className="icon-nav" alt="nav-icon-support" />;
            case 'Inventory':
                return <img loading="lazy" src={Inventory} className="icon-nav" alt="nav-icon-inventory" />;
            case 'Notifications':
                return <img loading="lazy" src={Notifications} className="icon-nav" alt="nav-icon-notifications" />;
            case 'Agencies':
                return <img loading="lazy" src={Agencies} className="icon-nav" alt="nav-icon-agencies" />;
            case 'Fleet AI':
                return <img loading="lazy" src={FleetIcon} className="icon-nav" alt="nav-icon-fleet" />;
            case 'Analytics':
                return <img loading="lazy" src={AnalyticsIcon} className="icon-nav" alt="nav-icon-analytics-dashboard" />;
            default:
                return null;
        }
    }

    return (
    <div
      className="nav-container-color"
      onMouseEnter={(e) => e.target.id === 'Notifications' && setShowMenu(true)}
    //   onMouseEnter={(e) => setShowMenu(true)}
      onMouseLeave={(e) => e.target.id === 'Notifications' && setShowMenu(false)}
    //   onMouseLeave={(e) => setShowMenu(false)}
      id={text}
      style={isActive
        ? { background: '#F9FAFB', cursor: 'pointer' } : { background: '#FFFFFF', cursor: 'pointer' }}
      onClick={(e) => stateChange(e, value)}
    >
        <div className="nav-justify">
            <div className="icon-nav-container">
                {navIcon()}
            </div>
            <div
              className="text-nav"
              style={isActive
            ? { color: '#101828' } : { color: '#344054' }}
              onClick={(e) => stateChange(e, value)}
            >
                {text}
            </div>
        </div>
        {text === 'Notifications' && (
            <NotificationBadge text={notificationAmount(data)} />
        )}
    </div>

    );
};

export default Navigation;
